import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Userprofile } from 'src/app/models/user/current-user.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit {
  userid: any;
  userprofile: Userprofile = new Userprofile();
  userimage: string = "";

  constructor(public activatedroute: ActivatedRoute, private router: Router, public headerinfo: ComponentheaderService, private usermanager: UseraccessserviceService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.userid = this.activatedroute.snapshot.queryParams.userid;
    this.userid = this.userid > 0 ? this.userid : 0;
    try {
      await this.getprofile(this.userid);
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(true);
    }
  }

  async getprofile(userid: any) {
    this.userprofile = await this.usermanager.getuserprofile(userid).toPromise();
    // this.userimage = (await this.usermanager.getuserprofileimage(userid).toPromise()).url + '?' + (new Date()).getTime();
    this.userimage = (await this.usermanager.getuserprofileimage(userid).toPromise()).url;
    var currentuserid: any = (await this.usermanager.isAlive().toPromise()).id;

    var adminaction = [];
    if (userid == 0 || userid == currentuserid) {
      adminaction = [{ displaytext: 'Edit Profile', route: '/user/editprofile', params: { userid: this.userid }, classes: ['fas', 'fa-edit'] },
      { displaytext: 'Change Password', route: '/user/updatepassword', params: {}, classes: ['fas', 'fa-lock'] }
      ];
    }
    this.headerinfo.setHeaderDisplay(
      'User Profile',
      [
        // { displaytext: 'Home', route: '/user' },
        { displaytext: 'User Profie', route: '/user/userprofile', params: this.activatedroute.snapshot.queryParams },
      ],
      adminaction
    );
  }

}
